import {Component, EventEmitter, Input, Output} from '@angular/core';

import {ChartBoxElement} from '../dashboard.interfaces';

@Component({
  selector: 'gp-progress-card',
  templateUrl: './progress-card.component.html'
})

export class ProgressCardComponent {
  @Input() public data: ChartBoxElement[];
  @Output() public selected: EventEmitter<{ metadata: any, value: number }> = new EventEmitter();

  constructor() {
  }

  public onSelect(element: ChartBoxElement): void {
    if (element.link) {
      this.selected.emit({metadata: element.link, value: element.value});
    }
  }
}
